module.exports = __webpack_public_path__ + "static/media/6.a3b8984e.jpg";